var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmarMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e74631",
    d: "M163 20C75 20 28 89 28 208s47 188 135 188 135-69 135-188S251 20 163 20zm0 68c43 0 61 40 61 120s-18 120-61 120-61-40-61-120 18-120 61-120z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17191a",
    d: "M140 4C52 4 5 73 5 192s47 188 135 188 135-69 135-188S228 4 140 4zm0 68c43 0 61 40 61 120s-18 120-61 120-61-40-61-120S97 72 140 72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmarMonogram);
export default __webpack_public_path__ + "static/media/omar-monogram.8b967aa947bdb2836a3f81e4341fec64.svg";
export { ForwardRef as ReactComponent };